var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-template"},[(_vm.modelReady)?_c('v-form-card',{attrs:{"flat":"","dObject":_vm.dataObject,"submit_button_caption":"Save","mainTabs":_vm.mainTabs,"hasParent":false,"noCache":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }